import { useEffect, useState } from "react";
import AlertText from "./AlertText";

interface PasswordProps {
  password: string;
  onEnableButton: (value: boolean) => void;
}
const PasswordRequireMents = (props: PasswordProps) => {
  const { password, onEnableButton } = props;
  const [requirementsMet, setRequirementsMet] = useState({
    length: false,
    upperCase: false,
    lowerCase: false,
    number: false,
    specialChar: false,
  });
  const getRequireMents = () => {
    return {
      length: password.length >= 6,
      upperCase: /[A-Z]/.test(password),
      lowerCase: /[a-z]/.test(password),
      number: /\d/.test(password),
      specialChar: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password),
    };
  };
  useEffect(() => {
    setRequirementsMet(getRequireMents());
  }, [password]);
  useEffect(() => {
    const isReqMet = Object.values(requirementsMet).some(
      (val) => val === false
    );
    onEnableButton(isReqMet);
  }, [requirementsMet]);

  return (
    <div style={{ marginTop: "10px" }}>
      <AlertText isMet={requirementsMet.length} text="At least 6 character" />
      <AlertText
        isMet={requirementsMet.upperCase}
        text="At least one UpperCase"
      />
      <AlertText
        isMet={requirementsMet.lowerCase}
        text="At least one LowerCase"
      />
      <AlertText
        isMet={requirementsMet.specialChar}
        text="At least one Special Character"
      />
      <AlertText isMet={requirementsMet.number} text="At least one Number" />
    </div>
  );
};
export default PasswordRequireMents;
